import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { ClassUtils } from "abweb/utils/ClassUtils";
import { ManualPromise } from "abweb/utils/ManualPromise";
/**
 * WARNING: this code does not gracefully handle exceptions
 */
export let AbMaybePromise;
(function (_AbMaybePromise) {
  function isPromise(maybePromise) {
    return ClassUtils.isInstanceOf(maybePromise, Promise) || ClassUtils.isInstanceOf(maybePromise, ManualPromise);
  }
  _AbMaybePromise.isPromise = isPromise;
  function map(maybePromise, consumer) {
    return isPromise(maybePromise) ? maybePromise.then(consumer) : consumer(maybePromise);
  }
  _AbMaybePromise.map = map;
  class Sequencer {
    constructor() {
      _defineProperty(this, "_accumulatedMaybePromise", undefined);
      this.sequence = this.sequence.bind(this);
    }
    sequence(maybePromise) {
      const sequencedMaybePromise = this._accumulatedMaybePromise ? map(this._accumulatedMaybePromise, () => maybePromise) // Resolve after all predecessors, transitively
      : maybePromise; // No predecessors

      this._accumulatedMaybePromise = sequencedMaybePromise;
      return map(sequencedMaybePromise, result => {
        // If no one has been sequenced since us, unset the accumulator to allow its reference to be garbage collected
        if (this._accumulatedMaybePromise === sequencedMaybePromise) {
          this._accumulatedMaybePromise = undefined; // Last one out, turn off the lights!
        }
        return result;
      });
    }
  }
  _AbMaybePromise.Sequencer = Sequencer;
})(AbMaybePromise || (AbMaybePromise = {}));
//# sourceMappingURL=AbMaybePromise.js.map
